export const FETCH_CURRENT_PAGE = "fetchCurrentPageData";
export const FETCH_JOB_DATA = "fetchJobData";
export const FETCH_BANNER_DATA = "fetchBannerData";
export const FETCH_CONTACT_DATA = "fetchContactData";
export const FETCH_NEWS_DATA = "fetchNewsData";
export const FETCH_PAGE_BY_ID = "fetchPageByID";
export const FETCH_CHILDREN = "fetchChildren";
export const FETCH_MAIN_MENU = "fetchMainMenu";
export const FETCH_RMAIN_MENU = "fetchRmainMenu";
export const FETCH_SOCIAL = "fetchSociallinkData";
export const FETCH_SETTING = "fetchSettinglinkData";
export const FETCH_GLOBAL = "fetchGlobalData";
export const FETCH_SETTING_DATA = "fetchSettingData";
